export enum InputTypes {
  TEXT = "TEXT",
  MULTI_LINE_TEXT = "MULTI_LINE_TEXT",
  NUMBER = "NUMBER",
  PHONE_NUMBER = "PHONE_NUMBER",
  EMAIL = "EMAIL",
  PASSWORD = "PASSWORD",
  CURRENCY = "CURRENCY",
}

export enum NumberInputStepButtonPosition {
  LEFT = "left",
  RIGHT = "right",
  NONE = "none",
}

export const HeightSizePx: any = {
  Small: "24px",
  Middle: "32px",
  Large: "40px",
};
